import BookkeepingDetails from './BookkeepingDetails';

export default BookkeepingDetails;
